import AxiosRequest from "./AxiosRequest";

export default class AddressVerificationService {
    constructor() {}

    async verifyAddress(address_line1, address_line2, city, state, zip) {
        const data = {
            address_line1,
            address_line2,
            city,
            state,
            zip // first 5 digits of the zip code
        };

        return new AxiosRequest().post("address/verify", data);
    }
}
